module.exports = __webpack_public_path__ + "img/tire-transparent.ab05a1e2.png";